// workaround to download file given a url
export const downloadFile = (url: string): void => {
  const link = document.createElement('a');
  link.href = url;
  link.download = 'true';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
